/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { UsersAuthzAllowPermissionToUserManagedPermissionsMutationResponse, UsersAuthzAllowPermissionToUserManagedPermissionsPathParams, UsersAuthzAllowPermissionToUserManagedPermissions401, UsersAuthzAllowPermissionToUserManagedPermissions403 } from "../models/UsersAuthzAllowPermissionToUserManagedPermissions";

export function getUsersAuthzAllowPermissionToUserManagedPermissionsUrl(userId: UsersAuthzAllowPermissionToUserManagedPermissionsPathParams["userId"], permission: UsersAuthzAllowPermissionToUserManagedPermissionsPathParams["permission"]) {
  const res = { method: 'POST', url: `/users-authz/v1/users/${userId}/permissions/${permission}/allow` as const }
  return res
}

/**
 * @description Requires CLIENT_ADMIN role or client API key
 * @summary Allow a permission for a user
 * {@link /users-authz/v1/users/:userId/permissions/:permission/allow}
 */
export async function usersAuthzAllowPermissionToUserManagedPermissions(userId: UsersAuthzAllowPermissionToUserManagedPermissionsPathParams["userId"], permission: UsersAuthzAllowPermissionToUserManagedPermissionsPathParams["permission"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<UsersAuthzAllowPermissionToUserManagedPermissionsMutationResponse, ResponseErrorConfig<UsersAuthzAllowPermissionToUserManagedPermissions401 | UsersAuthzAllowPermissionToUserManagedPermissions403>, unknown>({ method : "POST", url : getUsersAuthzAllowPermissionToUserManagedPermissionsUrl(userId, permission).url.toString(), ... requestConfig })
  return res.data
}